import HomePage from "../pages/HomePage";
import LoginPage from "../pages/LoginPage";
import TimingPage from "../pages/Timing/TimingPage";
import PitBoostPage from "../pages/Timing/PitBoostPage";
import PitBoostLeaderboardPage from "../pages/Timing/PitBoostLeaderboard";
import VirtualLoopsPage from "../pages/VirtualLoops";
import WinTAXPage from "../pages/WinTAX/WinTAXPage";
import WinTAXSummaryPage from "../pages/WinTAX/WinTAXSummaryPage";
import TPMSJaguarPage from "../pages/TPMS/TPMSJaguarPage";
import TPMSSummaryPage from "../pages/TPMS/TPMSSummaryPage";
import TVEnergyPage from "../pages/TVEnergy";
import V2LivePage from "../pages/Timing/V2LivePage";
import { RouteConfig, routeConfigs } from "./routeConfigs";
import TVEnergyGraphPage from "../pages/TVEnergy/TVEnergyGraph";
import TVEnergyTablePage from "../pages/TVEnergy/TVEnergyTable";
import ServerPage from "../pages/Admin/ServerPage";
import PerformanceMetricsPage from "../pages/PerformanceMetrics";
import ImportsPage from "../pages/Admin/ImportsPage";
import ErrorCodePage from "../pages/ErrorCodePage";
import FPAnalysisPage from "../pages/Timing/FPAnalysis";
import RadioPage from "../pages/Radio";
import RaceDataPage from "../pages/RaceData";
import LoopHeatMapPage from "../pages/Timing/LoopHeatMap";
import ReplayPage from "../pages/Replay";
import RacePage from "../pages/Race";
import RESSPage from "../pages/RESS";

type Route = {
  name: string;
  component: React.ComponentType<unknown>;
  path: string;
  showInNavBar: boolean;
  requiresPermission: boolean;
  permissionGroup: string | null;
  permissionBit: number | null;
  enabled: boolean;
};

// This must be separated from routeConfigs to avoid circular dependency issues,
// as routeConfigs is used in SideNav, which is used in the pages that are mapped here

const componentMap: Record<string, React.ComponentType<unknown>> = {
  "/": HomePage,
  "/login": LoginPage,
  "/timing": TimingPage,
  "/loop-heatmap": LoopHeatMapPage,
  "/race": RacePage,
  "/race-data": RaceDataPage,
  "/pit-boost": PitBoostPage,
  "/pit-boost-leaderboard": PitBoostLeaderboardPage,
  "/fp-analysis": FPAnalysisPage,
  "/wintax": WinTAXPage,
  "/wintax-summary": WinTAXSummaryPage,
  "/tpms-jaguar": TPMSJaguarPage,
  "/tpms-summary": TPMSSummaryPage,
  "/virtual-loops": VirtualLoopsPage,
  "/tv-energy": TVEnergyPage,
  "/performance-metrics": PerformanceMetricsPage,
  "/tv-energy-graph": TVEnergyGraphPage,
  "/tv-energy-table": TVEnergyTablePage,
  "/radio": RadioPage,
  "/v2-live": V2LivePage,
  "/replay": ReplayPage,
  "/ress": RESSPage,
  "/server": ServerPage,
  "/imports": ImportsPage,
  "/404": () => ErrorCodePage({ code: 404, message: "Page Not Found" }),
  "/403": () => ErrorCodePage({ code: 403, message: "Not Authorised" }),
};

export const routes: Record<string, Route> = Object.keys(routeConfigs).reduce(
  (acc, key) => {
    acc[key] = {
      ...(routeConfigs[key] as RouteConfig),
      component: componentMap[key],
    };
    return acc;
  },
  {} as Record<string, Route>,
);
